module.exports = __webpack_public_path__ + "66a83038c2c81b48339dcc8daf741f95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/syncs/screen.png
// module id = 1779
// module chunks = 1